export const getNavigatorLanguage = (): string => {
  if (typeof window === "undefined") {
    return "en-US";
  }

  const nav = window.navigator;
  return nav.languages?.[0] || nav.language || "en-US";
};
